import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

const ImageTitleContentCenter = ({ fields = {} }) => {
  const {
    heading = "",
    imageTileCards = [],
  } = fields;

  return (
    <section className={styles.virtualSuiteSection}>
      <div className={styles.virtualSuite}>
        {/* SECTION TITLE */}
        {heading && (
          <div className={styles.description}>
            <h2>{heading}</h2>
          </div>
        )}

        {/* CARDS */}
        {imageTileCards.length > 0 && (
          <div className={styles.cards}>
            {imageTileCards.map((card, index) => {
              const {
                imageUrl = "",
                title = "",
                internalTitle = "",
                src,
              } = card?.fields || {};

              return (
                <div
                  className={styles.card}
                  key={card?.sys?.id || internalTitle || index}
                >
                  <a href={src} target="_blank" className={styles.cardLink}>  
                  {/* IMAGE */}
                  {imageUrl && (
                    <div className={styles.imageWrapper}>
                      <img
                        src={imageUrl}
                        alt={title || internalTitle || "Resource"}
                        className={styles.image}
                      />
                    </div>
                  )}

                  {/* TITLE */}
                  {title && (
                    <div className={styles.caption}>
                      <h4>{title}</h4>
                    </div>
                  )}
                  </a>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

ImageTitleContentCenter.propTypes = {
  fields: PropTypes.shape({
    heading: PropTypes.string,
    imageTileCards: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          imageUrl: PropTypes.string,
          internalTitle: PropTypes.string,
          title: PropTypes.string,
          showBorder: PropTypes.bool,
          src: PropTypes.string,
        }),
        sys: PropTypes.shape({
          id: PropTypes.string,
        }),
      })
    ),
  }),
};

ImageTitleContentCenter.defaultProps = {
  fields: {
    heading: "",
    imageTileCards: [],
  },
};

export default ImageTitleContentCenter;